export default __webpack_public_path__ + "static/media/attachment-icon.0681a1e1.svg";